import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {ArticuloModel} from '../../../models/vmi-articuloModel';
import { VmiOrdeneService } from '../../../services/informes/vmi-ordenes-pedido.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SeguimientoModel } from '../../../models/vmi-seguimientoModel';
import { ItemsModel } from '../../../models/vmi-itemsModels';
import { CabSeguiModel } from '../../../models/vmi-cab-seguiModel';
import { VmiPenetracionService } from '../../../services/informes/vmi-penetracion.service';

@Component({
  selector: 'app-vmi-frm-mantenedor-pedidos',
  templateUrl: './vmi-frm-mantenedor-pedidos.component.html',
  styleUrls: ['./vmi-frm-mantenedor-pedidos.component.css']
})
export class VmiFrmMantenedorPedidosComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;
  myIframe: string = '';
  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;
  urlDestiny: string = "https://shipping.driv.in/tracking?token=eyJpc28iOiJlYyIsInBvc2l0aW9uIjpbeyJsYXQiOi0wLjk3NTQzNDMsImxuZyI6LTgwLjcyMjcyMX1dLCJsb2NhbGUiOiJlcyIsInRpbWVfem9uZSI6IlF1aXRvIiwidW5zdXNjcmliZWRfb3JnYW5pemF0aW9uX2lkIjpudWxsLCJ3aWRnZXRfdmVyIjoyLCJkYXRhX2Rpc3BsYXkiOnsiZ2VuZXJhbF9pbmZvIjp7Im9yZGVyX2NvZGUiOnRydWUsImFkZHJlc3MiOnRydWUsImNsaWVudF9uYW1lIjp0cnVlLCJjbGllbnRfY29kZSI6dHJ1ZSwiY29udGFjdF9lbWFpbCI6dHJ1ZSwiZXRhX2RlbGl2ZXJ5X3RpbWUiOnRydWUsImJpbGxpbmdfZGF0ZSI6dHJ1ZSwiY29tbWVudCI6dHJ1ZX0sIm9yZGVyX2luZm8iOnsiaXRlbXNfdGFibGUiOnRydWUsImltYWdlcyI6dHJ1ZSwicGRmIjp0cnVlfSwic3RlcF9pbmZvIjp7ImRyaXZlcl9uYW1lIjp0cnVlLCJ2ZWhpY2xlX2NvZGUiOnRydWUsInN0ZXBfbG9jYXRpb24iOnRydWUsInN0ZXBfZGF0ZXRpbWUiOnRydWV9fSwiZGF0YSI6eyJhcGlfa2V5IjoiNGQ1ZjZlZDctOTcwOS00ZDA5LTg2Y2ItOTQ1NmFiYzU5MWRjIn19";

  //Main
  columnSeguiDefs: any[];
  rowSeguiData: SeguimientoModel[] = [];
  frameworkSeguiComponents: any;
  gridSeguiApi: any;
  gridColumnSeguiApi: any;
  rowSeguiSelection: any;
  //Details
  columnItemDefs: any[];
  rowItemsData: ItemsModel[] = [];
  frameworkItemsComponents: any;
  gridItemsApi: any;
  gridColumnItemsApi: any;
  rowItemsSelection: any;

  cabeceraSegui : CabSeguiModel = new CabSeguiModel();
  seguimiento : SeguimientoModel[] = [];
  items : ItemsModel[] = [];

  urlPdf: string = '';
  order:string = '';
  estado:string = '';

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  constructor(
    private fb: FormBuilder,
    private _penetracion: VmiPenetracionService,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _ordenes: VmiOrdeneService,
    public sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.articulo;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      fechaInicio: ['', [Validators.required]],
      fechaFinal: ['', [Validators.required]]
    });

    this.gridComponent();
    this.gridSeguiComponent();
    this.gridItemComponent();
    //this.getAll();
  }

  //*SERVICIOS
  getAll() {
    this._ordenes.getPedidoFecha('2024-06-10','2024-06-14').subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'Orden',
        field: 'OrdenId',
        sortable: true,
        filter: true,
        width: 130
      },
      {
        headerName: 'Factura',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.imprimir.bind(this),
          label: 'Imprimir',
          colorBoton: 'btn btn-warning btn-block'
        }
      },
      {
        headerName: 'COA',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.imprimirCoa.bind(this),
          label: 'Imprimir',
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      },
      {
        headerName: 'Fecha Orden',
        field: 'FechaOrden',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Nombre del transportista',
        field: 'NombreTransport',
        sortable: true,
        resizable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'Fecha prev. entrega',
        field: 'FechaEntregaCab',
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'Fecha de entrega',
        field: 'fechaEntregaCab',
        sortable: true,
        filter: true,
        width: 160,
      },
      {
        headerName: 'Hora entrega',
        field: 'horaEntrega',
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'Origen',
        field: 'CentroOrigen',
        sortable: true,
        resizable: true,
        filter: true,
        width: 150
      },{
        headerName: 'Detalle',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.visualizar.bind(this),
          label: 'Ver',
          colorBoton: 'btn btn-info btn-block'
        }
      }
      /*{
        headerName: 'Estatus',
        field: 'StatEntrega',
        sortable: true,
        filter: true,
        width: 200,
        valueGetter: function (data) {
          switch(data.data.StatEntrega){
            case 'A':
              return 'No tratado';
            case 'B':
              return 'Parcial';
            case 'C':
              return 'Completo';  
            default:
              return '?';    
          }
          
        }
      },*/
      
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  gridSeguiComponent() {
    
    this.columnSeguiDefs = [
      {
        headerName: 'TITULO',
        field: 'titulo',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'FECHA',
        field: 'fecha',
        sortable: true,
        filter: true,
        width: 210
      },
      {
        headerName: 'UBICACION',
        field: 'ubicacion',
        sortable: true,
        resizable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'CONDUCTOR',
        field: 'conductor',
        wrapText: true,
        autoHeight: true,
        sortable: true,
        filter: true,
        resizable: true,
        width: 160
      },
      {
        headerName: 'VEHICULO',
        field: 'vehiculo',
        sortable: true,
        filter: true,
        width: 180
      }
    ];
  
  this.frameworkSeguiComponents = {
    buttonRenderer: LfsaBotonEditarGridComponent,
  };
  this.rowSeguiSelection = 'multiple';
}

gridItemComponent() {
  
  this.columnItemDefs = [
    {
      headerName: 'CODIGO',
      field: 'code',
      sortable: true,
      filter: true,
      width: 150
    },
    {
      headerName: 'DESC. ITEM',
      field: 'description',
      wrapText: true,
      autoHeight: true,
      sortable: true,
      resizable: true,
      filter: true,
      width: 150
    },      
    {
      headerName: 'DESPACHADAS',
      field: 'units',
      sortable: true,
      filter: true,
      width: 100
    },
    {
      headerName: 'ENTREGADAS',
      field: 'delivered_units',
      sortable: true,
      filter: true,
      width: 100
    },
    {
      headerName: 'ESTADO',
      field: 'status',
      sortable: true,
      filter: true,
      width: 160,
      valueGetter: function (data) {
        switch(data.data.status){
          case "pending":
            return 'Pendiente';
          case 'delivered':
            return 'Entregado' ;
          case 'approved':
            return 'Aprobado';  
          default:
            return data.data.status;  
        }
      }
    }
  ];

this.frameworkItemsComponents = {
  buttonRenderer: LfsaBotonEditarGridComponent,
};
this.rowItemsSelection = 'multiple';
}

onGridSeguiReady(params) {
  this.gridSeguiApi = params.api;
  this.gridColumnSeguiApi = params.columnApi;
}

onGridItemReady(params) {
  this.gridItemsApi = params.api;
  this.gridColumnItemsApi = params.columnApi;
}

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  editar({rowData}) {
    const obj: ArticuloModel = {
      artId: rowData.artId,
      artDescripcion: rowData.artDescripcion === undefined ? '' : rowData.artDescripcion,
      artUndStock: rowData.artUndStock === undefined ? '' : rowData.artUndStock,
      artCodigoInterno: rowData.artCodigoInterno === undefined ? '' : rowData.artCodigoInterno,
      artCont: rowData.artCont === undefined ? '' : rowData.artCont,
      artEstado: rowData.artEstado === undefined ? '' : rowData.artEstado,
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  imprimir({rowData}){
    this.loading = true;
    console.log(rowData);
    console.log(rowData.ClaveAccesoFact);
    if(typeof rowData.ClaveAccesoFact!='undefined' && rowData.ClaveAccesoFact){
      this._ordenes.getDocFactura(
        rowData.ClaveAccesoFact//'1006202407139001294900120010510000001411390012916'
      ).subscribe((res: any) => {
        console.log(res);
        if(res.descp !== undefined)
          this._utils.descargarArchivoV2('FACT_'+rowData.OrdenId,res.descp,'pdf')
        else
          this._utils.mensajeErroToast('No existe factura para este registro');
        
        this.loading = false;
      }, (err) => {
        this._utils.alertifyToastWar('No se pudo obtener información del siguiente documento: '+rowData.NumeroFactura);
        console.log(err);
        this.loading = false;
      });
   }else{
      this._utils.alertifyToastWar('No existe numero de Factura para este pedido');
   } 
    
  }

  imprimirCoa({rowData}){
    console.log(rowData);
    if(rowData.Coa !== undefined){
      console.log(rowData.Coa);
      this._utils.descargarArchivoV2('COA_'+rowData.OrdenId,rowData.Coa,'pdf');
    }
    //document.getElementById('abrirModal').click();
  }

  /*eliminar({rowData}) {
    const articulo: ArticuloModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._articulos.delete(articulo.artId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }*/

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        //this.actualizar();
      } else {
        //this.guardar();
      }
    } else {
      this.regresar();
    }
  }


  buscarPorFecha(){
    this.loading = true;
    this._ordenes.getPedidoFecha(
                  this.formulario.get('fechaInicio').value,
                  this.formulario.get('fechaFinal').value
                                ).subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  } 

  regresar() {
    this.mostrarFormulario = false
    this.listaVacia = false;
  }

  generarSeguimiento(orden:string){
    this.loading = true;
    this.listaVacia = true;
    let estadoRuta= "";
    let ciudad = "";
    let fechs = "";
    this._penetracion.getPenetracionFiltradoSegumientoRaw(orden).subscribe(
      (res: any) => {
        this.loading = false;
        console.log(res);
        if(res.data !== undefined){
          this.seguimiento = [];
          this.items = [];
          this.listaVacia = false;
          if(res.data.tracking.length > 0){
            this.urlPdf = res.data.tracking[0].address.order.url_pdf;
            let namba = 0;
            for (let mainItem of res.data.tracking[0].history){
              console.log(res.data.tracking[0].history[namba].events);
              for( let item of res.data.tracking[0].history[namba].events){
                let num = 1;
                if(item.datetime > fechs){
                  fechs = item.datetime;
                  estadoRuta = item.widget_event_name;
                  this.estado = mainItem.order.customer_status;
                }
                //if(/*num ===1 && namba === 1*/item.event_type === 'approved_pod'){
                //  estadoRuta = item.widget_event_name;
                //}
                num++;
                ciudad = item.widget_location_area;
                this.seguimiento.push(new SeguimientoModel(
                  item.widget_event_name,
                  item.widget_location_area,
                  item.datetime,
                  res.data.tracking[0].history[namba].vehicle_result.driver,
                  res.data.tracking[0].history[namba].vehicle_result.vehicle));
              }
              this.rowSeguiData = this.seguimiento;
              for( let item of res.data.tracking[0].history[namba].order.items){
                this.items.push(new ItemsModel(
                  item.code,
                  item.description,
                  item.units,
                  item.delivered_units,
                  item.item_status,
                  item.reason,
                  item.requested_units
                  ));
              }
              namba++;
            }
            

          }else{
              this._utils.mensajeErrorVisto('Flete no generado', true, 10000, 'La Orden '+orden+' en Driv.in aún no ha sido generada');
              this.listaVacia = true;
              this.regresar();
              return;
          }
        }
        this.rowItemsData = this.items;
        this.cabeceraSegui.codCliente = res.data.tracking[0].address.code;
        this.cabeceraSegui.nomCliente = res.data.tracking[0].client;
        this.cabeceraSegui.direccion = res.data.tracking[0].address.address;
        this.cabeceraSegui.horaEstimada = res.data.tracking[0].address.eta;
        this.cabeceraSegui.estadoRuta = estadoRuta;
        this.cabeceraSegui.ciudad = ciudad;
        this.cabeceraSegui.esquema = res.data.tracking[0].schema_name;
        this.cabeceraSegui.direccionEsquema = res.data.tracking[0].schema_address;
        console.log(fechs);
        switch(this.estado){
            case 'assigned':
              this.estado = 'ASIGNADO';
            break;
            case 'pending':
              this.estado = 'PENDIENTE';
            break;
            case 'approved':
              this.estado = 'APROBADO'
            break; 
            case 'in-transit':
              this.estado = 'EN TRÁNSITO';
            break;  
            default:
              this.estado = res.data.tracking[0].address.order.status;    
        }
        this.estado
      }, (err) => {
        this.loading = false;
        console.log(err);
      }
    );
}

abrirLink(){
  console.log(this.urlPdf)
  window.open(this.urlPdf);
}

visualizar({rowData}) {
  console.log(rowData);
  if(typeof rowData.UnidadFlete!='undefined' && rowData.UnidadFlete){
    this.order = rowData.UnidadFlete;
    this.editableForm = false;
    this.mostrarFormulario = true;
    this.generarSeguimiento(rowData.UnidadFlete);
 }else{
    this._utils.alertifyToastWar('No existe numero flete para este pedido');
 } 
}

}
